import {DrawText} from '@platform/ui/DrawReference';
import {drawNumber} from '@platform/contracts/drawNumber';
import type {Snapshot} from '@platform/contracts/x';
import {money} from '@platform/client';
import {useCopy} from '@platform/ui/config';
import {RoomNotice} from './RoomNotice';
import {hasParticipation,isCancelled} from './roomFlow';

// Native purchase modals suppress the timed celebration. Keep its confirmed
// result readable without extending or replaying the server's presentation.
export function PurchaseDrawResultNotice({result}:{result:Snapshot|null}){
 const t=useCopy();
 if(!result||!hasParticipation(result))return null;
 const draw=drawNumber(result);
 if(isCancelled(result))return <RoomNotice noticeKey="flow.previousCancelled" dismissKey={result.drawId} tone="warning" data-purchase-result={result.drawId}><DrawText copyKey="flow.previousCancelled" draw={draw}/> {t(result.tombala.refundedMinor>=result.tombala.ownTotalMinor?'flow.refundConfirmed':'flow.refundPending')}</RoomNotice>;
 if(result.tombala.ownPayoutMinor<=0)return null;
 return <RoomNotice noticeKey="flow.purchaseDrawWon" dismissKey={result.drawId} tone="success" data-purchase-result={result.drawId}><DrawText copyKey="flow.purchaseDrawWon" draw={draw} values={{amount:money(result.tombala.ownPayoutMinor,result.currency)}}/></RoomNotice>;
}
